'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { GoArrowDown } from 'react-icons/go';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function MemberZoneHeader() {
  const { t } = useTranslations();

  function scrollDown() {
    const scrollDistance = window.innerWidth <= 640 ? 350 : 500;
    window.scrollTo({
      top: window.scrollY + scrollDistance,
      behavior: 'smooth',
    });
  }

  return (
    <section className={cn('relative w-full bg-[#0B2649] pt-[72px] sm:pt-20 md:pt-28')}>
      <Image
        src={'/images/header-triangle.svg'}
        alt="Design"
        width={0}
        height={0}
        className="absolute -top-[20px] left-0 z-[1] h-11 w-auto sm:h-12 md:-top-[40px] md:h-[91px]"
      />
      <Image
        src={'/images/subpage-overlay.jpg'}
        alt={t('text2398')}
        width={0}
        height={0}
        className="absolute inset-0 h-full w-full object-cover object-center opacity-65 mix-blend-luminosity"
        sizes="100vw"
      />
      <div className={cn('custom-section', 'relative z-10')}>
        <div
          className={cn(
            'custom-container',
            'flex flex-col items-start justify-start gap-2.5 sm:gap-3 md:gap-4 lg:gap-5',
          )}
        >
          <h2 className="text-2xl font-extralight -tracking-tight text-white sm:text-3xl md:text-4xl lg:text-5xl">
            {t('text2405')}
            <br />
            <strong className="text-3xl font-bold leading-snug sm:text-4xl sm:leading-snug md:text-5xl md:leading-snug lg:text-6xl lg:leading-snug">
              SEDMA
            </strong>
          </h2>
        </div>
      </div>
      <div className="relative z-10 w-full">
        <div
          className={cn(
            'custom-container',
            'absolute bottom-0 left-1/2 z-10 flex -translate-x-1/2 items-end justify-end px-5 sm:bottom-4 lg:bottom-8 xl:px-0',
          )}
        >
          <Button onClick={scrollDown} variant={'outline'}>
            {t('text2404')} <GoArrowDown size={20} />
          </Button>
        </div>
        <Image
          src={'/images/body-triangle.svg'}
          alt="Design"
          width={0}
          height={0}
          className="h-[90px] w-full translate-y-[1px] object-cover md:h-auto"
        />
      </div>
    </section>
  );
}
